import React, { useEffect, useState } from "react";
import CollectionPage from "../CollectionPage";
import { getBoldBright, PRODUCTS_PER_PAGE } from "../../data/boldBright";
import SEOHead from "../../components/common/SEOHead";
import ProductListSchema from "../../components/common/ProductListSchema";
import FAQSchema from "../../components/common/FAQSchema";

const PAGE_URL = "https://aishcraft.com/bold-bright";

const boldBrightFAQs = [
  {
    question: "What makes bold & bright sketchbooks different?",
    answer: "Bold & bright sketchbooks feature vibrant, energetic cover designs with premium paper quality suited for sketching and creative work.",
  },
  {
    question: "Can I personalize the cover with my name?",
    answer: "Yes, every sketchbook can be customized with your name, initials, or a custom design on the cover.",
  },
  {
    question: "How long does delivery take?",
    answer: "Personalized sketchbooks are made to order and typically ship within 6 working days across India.",
  },
];

export default function BoldBright() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getBoldBright()
      .then(setProducts)
      .catch((err) => setError(err.message || "Failed to load products"));
  }, []);

  const seo = (
    <SEOHead
      title="Bold & Bright Sketchbooks | Personalized Notebooks"
      description="Shop 300+ beautifully designed bold & bright sketchbooks. Premium paper quality, customizable — notebooks that match your energy."
      url={PAGE_URL}
      breadcrumbs={[
        { name: "Home", item: "https://aishcraft.com/" },
        { name: "Notebooks", item: "https://aishcraft.com/notebooks" },
        { name: "Bold & Bright", item: PAGE_URL },
      ]}
    />
  );

  if (error) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>
      </>
    );
  }

  if (!products) {
    return (
      <>
        {seo}
        <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>
      </>
    );
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/bold-bright",
    announcement: {
      headline: "Bold colours, bright ideas — new collection is here!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Sketchbook",
      subtitle: "Notebooks that match your energy",
      featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "Finally a notebook that's as loud as my personality — and the paper quality is unreal.",
      quoteLink: "#",
      rating: "4.6",
      ratingCount: "500+",
    },
  };

  return (
    <>
      {seo}
      <ProductListSchema products={products} pageUrl={PAGE_URL} />
      <FAQSchema faqs={boldBrightFAQs} />
      <CollectionPage config={config} />
    </>
  );
}